<template>
  <section class="crm-block">
    <div class="crm-block_header">
      <span
        class="crm-block_header_icon"
        :style="{
          'background-image': `url(${ titleImage })`,
          'background-size': '100% 100%',
        }"
      />
      <span class="crm-block_header_title">
        {{ title }}
      </span>
    </div>
    <div class="crm-block_content">
      <div class="crm-block_content_item crm-block_content_item-left" v-on:click="clickEvent[0]">
        <span class="crm-block_content_tag-lateral" >
          {{ contentItems[0].value }}
          <span v-show="contentItems[0].isTenThousand" style="font-size: 16px">万</span>
          <span v-show="contentItems[0].isBillThousand" style="font-size: 16px">亿</span>
        </span>
        <span class="crm-block_content_tag">{{ itemTitle[0] }}</span>
      </div>
      <div class="crm-block_content_item crm-block_content_item-center" v-on:click="clickEvent[1]">
        <span class="crm-block_content_tag-center">
          {{ contentItems[1].value }}
          <span v-show="contentItems[1].isTenThousand" style="font-size: 20px">万</span>
          <span v-show="contentItems[1].isBillThousand" style="font-size: 16px">亿</span>
        </span>
        <span class="crm-block_content_tag">{{ itemTitle[1] }}</span>
      </div>
      <div class="crm-block_content_item crm-block_content_item-right" v-on:click="clickEvent[2]">
        <span class="crm-block_content_tag-lateral">
          {{ contentItems[2].value }}
          <span v-show="contentItems[2].isTenThousand" style="font-size: 16px">万</span>
          <span v-show="contentItems[2].isBillThousand" style="font-size: 16px">亿</span>
        </span>
        <span class="crm-block_content_tag">{{ itemTitle[2] }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    titleImage: String,
    itemTitle: Array,
    contentItems: Array,
    clickEvent: Array,
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/const.less';

.crm-block {
  position: relative;
  width: 100%;
  height: 240px;
  margin-bottom: 20px;
  background: rgba(255,255,255,1);
  box-shadow: 0px 4px 20px 0px rgba(41,36,80,0.2);
  border-radius: 4px;
  &_header {
    width: 100%;
    height: 60px;
    background:rgba(240,243,255,1);
    border-radius: 4px 4px 0px 0px;
    &_icon {
      position: absolute;
      left: 20px;
      top: -10px;
      width: 60px;
      height: 60px;
      background: linear-gradient(180deg,rgba(177,192,255,1) 0%,rgba(240,243,255,1) 100%);
    }
    &_icon:before {
      position: absolute;
      left: -4px;
      top: -4px;
      width: 60px;
      height: 60px;
      background: linear-gradient(180deg,rgba(177,192,255,1) 0%,rgba(240,243,255,1) 100%);
    }
    &_icon:after {
      position: absolute;
      left: -2px;
      top: -2px;
      width: 60px;
      height: 60px;
      background: linear-gradient(180deg,rgba(177,192,255,1) 0%,rgba(240,243,255,1) 100%);
    }
    &_title {
      margin-left: 100px;
      height: 22px;
      line-height: 60px;
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(14,21,59,1);
    }
  }
  &_content {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    height: calc(100% - 60px);
    &_tag {
      display: block;
      max-width: 110px;
      padding: 0 10px;
      height: 24px;
      text-align: center;
      background: @tb-head-bg;
      border-radius: 12px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: @color--info;
      line-height: 24px;
    }
    &_tag-center {
      margin-top: -10px;
      font-size: 32px;
      line-height: 50px;
      color: @color--link;
      font-weight: bold;
    }
    &_tag-lateral {
      margin-top: -10px;
      font-size: 20px;
      line-height: 50px;
      color: @color--info;
      font-weight: 500;
    }
    &_item {
      cursor: pointer;
    }
    &_item-left, &_item-right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 84px;
      &_total {
        height: 38px;
        font-size: 32px;
        font-family: HelveticaNeue-Medium;
        font-weight: 500;
        color: rgba(122,132,183,1);
        line-height: 39px;
      }
    }
    &_item-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 120px;
      &_total {
        font-size: 52px;
        font-family: HelveticaNeue-Bold;
        font-weight: bold;
        color: rgba(53,80,225,1);
        line-height: 64px;
      }
    }
  }
}
</style>
